import React from "react";

import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./SearchInput.module.css";

interface Props {
  searchInput: string;
  setSearchInput: (s: string) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  hideSearchIcon?: boolean;
  onClick?: () => void;
  showClearButton?: boolean;
  onClear?: () => void;
}

const SearchInput: React.FC<Props> = ({
  searchInput,
  setSearchInput,
  placeholder = "Search...",
  className,
  inputClassName,
  hideSearchIcon,
  onClick,
  showClearButton,
  onClear,
}) => {
  return (
    <div className={toClassName(styles.container, className)}>
      {hideSearchIcon !== true && <SearchIcon className={styles.icon} />}

      <input
        className={toClassName(styles.input, inputClassName)}
        value={searchInput}
        placeholder={placeholder}
        type={"text"}
        onChange={(e) => setSearchInput(e.target.value)}
        onClick={onClick}
      />
      {showClearButton && (
        <div className={styles.clearFilterContainer}>
          <ClearIcon className={styles.clearIcon} onClick={onClear} />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
